module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_10_C_3.941388ec.mp3";